"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webengagePlugin = userConfig => {
    let logger;
    let eventNames;
    let eventAttributes;
    return {
        name: 'webengage',
        initialize: ({ logger: loggerL, eventNames: eventNamesL, eventAttributeNames: eventAttributesL, }) => {
            logger = loggerL;
            eventNames = eventNamesL;
            eventAttributes = eventAttributesL;
            logger.debug('Webengage: Not initializing, expecting GTM to load webengage for now');
        },
        trackEvent: (eventName, attributes) => {
            if (window.webengage) {
                window.webengage.track(eventName, attributes);
                logger.debug(`Webengage: Event: ${eventName}`, attributes);
            }
        },
        trackScreen(screenName, attributes) {
            if (window.webengage) {
                window.webengage.track(eventNames.SCREEN_VIEW, {
                    ...attributes,
                    [eventAttributes.SCREEN_NAME]: screenName,
                });
            }
        },
        trackClick(CTA, screenName, attributes) {
            if (window.webengage) {
                window.webengage.track(eventNames.CLICK, {
                    ...attributes,
                    [eventAttributes.CTA]: CTA,
                    [eventAttributes.SCREEN_NAME]: screenName,
                });
            }
        },
        login(userId) {
            if (window.webengage) {
                window.webengage.user.login(userId);
            }
        },
        logout() {
            if (window.webengage) {
                window.webengage.user.logout();
            }
        },
        canTrackAllEvents: () => userConfig?.trackAllEvents ?? false,
    };
};
exports.default = webengagePlugin;
//# sourceMappingURL=webengage.js.map